export default __webpack_public_path__ + "static/invoiceListCombined-977971b484a6c19d49052a5453404ab2.webp";